import { siteInfo } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 z-0">
        <img
          src={siteInfo.heroImage}
          alt="樱花TV - 高清影视观影体验"
          className="w-full h-full object-cover object-center"
          style={{ filter: 'brightness(0.35)' }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/80 via-background-50/40 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-4 md:px-6 py-16 md:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-500/15 border border-primary-500/25 mb-5">
              <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
              <span className="text-xs text-primary-400 font-medium">片库每日更新 200+ 部</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading text-foreground-950 leading-tight tracking-wide">
              {siteInfo.name} · {siteInfo.slogan}
            </h1>

            <p className="mt-5 text-sm md:text-base text-foreground-500 leading-relaxed max-w-xl mx-auto lg:mx-0">
              {siteInfo.description}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mt-7">
              {siteInfo.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-bold text-primary-400 font-heading">
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-8">
              <a
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-white rounded-md hover:bg-primary-600 transition-colors font-medium text-sm whitespace-nowrap text-center cursor-pointer"
              >
                开始观影
              </a>
              <a
                href="#features"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#features')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3 border border-foreground-300/40 text-foreground-600 rounded-md hover:border-primary-400/50 hover:text-primary-400 transition-colors text-sm whitespace-nowrap text-center cursor-pointer"
              >
                了解更多
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none hidden md:block">
            <div className="relative">
              <div className="absolute -inset-4 bg-primary-500/10 rounded-2xl blur-2xl"></div>
              <div className="relative rounded-xl overflow-hidden border border-background-300/50">
                <img
                  src={siteInfo.heroImage}
                  alt="樱花TV - 超清画质观影平台"
                  className="w-full h-auto object-cover"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-background-50/90 to-transparent p-5 pt-12">
                  <div className="flex items-center gap-3">
                    <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500 text-white cursor-pointer">
                      <i className="ri-play-fill text-lg"></i>
                    </span>
                    <div>
                      <p className="text-xs text-foreground-400">热门推荐</p>
                      <p className="text-sm text-foreground-700 font-medium">本周口碑电影TOP10</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="absolute -bottom-3 -right-3 bg-background-100 border border-background-300/60 rounded-lg px-3 py-2 shadow-lg">
                <p className="text-xs text-foreground-400">当前画质</p>
                <p className="text-sm text-primary-400 font-semibold font-heading">4K HDR</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}